export enum PaymentGateway {
  SHOPIFY = "SHOPIFY",
  M_AND_H = "M_AND_H",
}
